export default __webpack_public_path__ + "static/media/rust.c4e10f91.ico";